
/*eslint-disable*/
// @ts-nocheck
import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";

import {
  Box,
  Button,
  TextField,
  FormControl,
  Select,
  MenuItem,
  InputLabel,
  Checkbox,
  FormControlLabel,
  Alert,
  Chip,
  ListItemText,
  OutlinedInput
} from "@mui/material";
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import { RenderIf, LoadingSpinner } from "@adl/smart-ui-library";
import axiosInstance from "../../axiosConfig";
import axios from "axios";
import {
  selectSelectedDocument,
} from "@/redux/casesSlice";
import { useAppSelector } from "@/hooks";

import {
  FilePond,
  type FilePond as ReactFilePond,
} from "react-filepond";
import type { FilePond as FilePondInstance } from "filepond";

const FileMetaModal = ({

  data,

}) => {
  const navigate = useNavigate();
  const document = useAppSelector(selectSelectedDocument);

  const [disableSubmit, setDisableSubmit] = React.useState(true);
  const [fileName, setFileName] = React.useState(document?.fileNameOriginal || '');
  const [filenameError, setFilenameError] = React.useState('');
  const [message, setMessage] = React.useState('');
  const [practices, setPractices] = useState([]);
  const [industries, setIndustries] = useState([]);
  const [categories, setCategories] = useState([]);
  const [markets, setMarkets] = useState([]);
  const [subindustries, setSubindustries] = useState([]);
  const [functionalTopic1, setFunctionalTopic1] = useState([]);
  const [functionalTopic2, setFunctionalTopic2] = useState([]);

  const [selectedFunctionalTopic1Labels, setSelectedFunctionalTopic1Labels] = useState(Object.fromEntries(
    (document?.functionalTopicsL1 || []).map(item => [
      item.functionalTopicL1Id,
      item.functionalTopicL1
    ])
  ) || {});
  const [selectedFunctionalTopic2Labels, setSelectedFunctionalTopic2Labels] = useState(Object.fromEntries(
    (document?.functionalTopicsL2 || []).map(item => [
      item.functionalTopicL2Id,
      item.functionalTopicL2
    ])
  ) || {});
  const [marketInputValue, setMarketInputValue] = useState('');
  const filePondRef = useRef<ReactFilePond | null>(null);
  const [files, setFiles] = React.useState<any[]>([]);
  const [isUploading, setIsUploading] = React.useState<boolean>(false);
  const [consent, setConsent] = useState(false);
  const [metadata, setMetadata] = useState({
    accountIndustryId: document?.accountIndustryId || null,
    functionalTopicL1Ids: document?.functionalTopicsL1.map(item => item.functionalTopicL1Id) || [],
    functionalTopicL2Ids: document?.functionalTopicsL2.map(item => item.functionalTopicL2Id) || [],
    authorEmails: document?.authors.map(item => item) || [],
    practiceIds: document?.practices.map(item => item.practiceId) || [],
    categoryId: document?.category[0]?.categoryId || null,
    industryId: document?.industryId || null,
    accountSubindustryL1Ids: document?.accountSubindustries.map(item => item.subindustryL1Id) || [],
    marketIds: document?.markets.map(item => item.marketId) || []
  });
  const [error, setError] = useState(false);

  const onLoadPractices = async () => {
    try {
      const response = await axiosInstance.get("documents/practices");
      setPractices(response.data.results);
      console.log(error)
    } catch (error: any) {
      setError(true);
    }

  };

  const onLoadMarkets = async () => {
    try {
      const response = await axiosInstance.get("documents/markets");
      setMarkets(response.data.results);
      console.log(error)
    } catch (error: any) {
      setError(true);
    }

  };
  const onLoadIndustries = async () => {
    try {
      const response = await axiosInstance.get("documents/industries");
      setIndustries(response.data.results);


    } catch (error: any) {
      setError(true);
    }

  };
  const onLoadSubIndustries = async () => {
    try {
      const response = await axiosInstance.get("documents/subindustries", { params: { industryId: metadata.accountIndustryId || 1 } });
      setSubindustries(response.data.results);


    } catch (error: any) {
      setError(true);
    }

  };
  const onLoadFunctionalTopic1 = async () => {
    try {
      if (metadata.practiceIds.length === 0) {
        setFunctionalTopic1([]);
        return;
      }
      // Fetch topics for all selected practices
      const requests = metadata.practiceIds.map(practiceId =>
        axiosInstance.get("documents/functional-topics-l1", {
          params: { practiceId }
        })
      );
      const responses = await Promise.all(requests);
      // Merge all results, removing duplicates
      const allTopics = responses.flatMap(res => res.data.results);
      const uniqueTopics = Array.from(new Map(allTopics.map(topic => [topic.functionalTopicL1Id, topic])).values());
      setFunctionalTopic1(uniqueTopics);
    } catch (error: any) {
      setError(true);
    }
  };
  const onLoadFunctionalTopic2 = async () => {
    try {
      if (metadata.functionalTopicL1Ids.length === 0) {
        setFunctionalTopic2([]);
        return;
      }
      // Fetch topics for all selected practices
      const requests = metadata.functionalTopicL1Ids.map(functionalTopicL1Id =>
        axiosInstance.get("documents/functional-topics-l2", {
          params: { functionalTopicL1Id }
        })
      );
      const responses = await Promise.all(requests);
      // Merge all results, removing duplicates
      const allTopics = responses.flatMap(res => res.data.results);
      const uniqueTopics = Array.from(new Map(allTopics.map(topic => [topic.functionalTopicL2Id, topic])).values());
      setFunctionalTopic2(uniqueTopics);
    } catch (error: any) {
      setError(true);
    }
  };


  const onLoadCategory = async () => {
    try {
      const response = await axiosInstance.get("documents/categories?type=nonpcode");
      setCategories(response.data.results);

    } catch (error: any) {
      setError(true);
    }
  };

  const validateFilename = (name) => {
    const regex = /^[a-zA-Z0-9 ._()-]+$/;
    if (!regex.test(name)) {
      setFilenameError('File name cannot have special characters.');
      return false;
    }
    setFilenameError('');
    return true;
  };

  const handleFileName = (v) => {
    const newFilename = v;
    setFileName(newFilename);
    validateFilename(newFilename);
    setMetadata((prev) => ({
      ...prev,
      fileName: newFilename,
    }));
  };

  const handleChange = (value, name) => {
    if (name === 'functionalTopicL1Ids') {
      const newLabels = { ...selectedFunctionalTopic1Labels };
      value.forEach(id => {
        if (!newLabels[id]) {
          const topic = functionalTopic1.find(m => m.functionalTopicL1Id === id);
          if (topic) newLabels[id] = topic.functionalTopicL1;
        }
      });
      setSelectedFunctionalTopic1Labels(newLabels);
    }
    if (name === 'functionalTopicL2Ids') {
      const newLabels = { ...selectedFunctionalTopic2Labels };
      value.forEach(id => {
        if (!newLabels[id]) {
          const topic = functionalTopic2.find(m => m.functionalTopicL2Id === id);
          if (topic) newLabels[id] = topic.functionalTopicL2;
        }
      });
      setSelectedFunctionalTopic2Labels(newLabels);
    }
    setMetadata((prev) => ({
      ...prev,
      [name]: value,
    }));
    e.stopPropagation()
  };

  useEffect(() => {
    validateFilename(data?.file?.name)
    setMetadata((prev) => ({
      ...prev,
      fileName: data?.file?.name,
    }));
  }, [data]);

  const validateForm = () => {
    const {
      accountIndustryId,
      functionalTopicL1Ids,
      functionalTopicL2Ids,
      authorEmails,
      practiceIds,
      categoryId,
      industryId,
      accountSubindustryL1Ids,
      marketIds } = metadata;

    if (!fileName) return false;

    if (!accountIndustryId && practiceIds.length === 0) return false;

    if (marketIds.length === 0) return false;
    if (authorEmails.length === 0) return false;
    if (!categoryId) return false;
    if (accountIndustryId && accountSubindustryL1Ids.length === 0) return false;
    if (
      practiceIds.length > 0 &&
      functionalTopicL1Ids.length === 0 &&
      functionalTopicL2Ids.length === 0
    ) return false;
    if (!consent) return false;

    return true;
  };

  useEffect(() => {
    onLoadPractices()
    onLoadMarkets()
    onLoadIndustries()
    onLoadSubIndustries()
    onLoadFunctionalTopic1()
    onLoadFunctionalTopic2()
    onLoadCategory()
    const isFormFilled = validateForm();
    console.log(isFormFilled, metadata)
    setDisableSubmit(!isFormFilled)
  }, [metadata, consent]);

  const handleFileAdd = (error, file: any) => {
    if (!error) {
      setFileName(file.filename)
      setFiles((prevFiles) => [...prevFiles, file]);
      handleFileName(file.filename)
    }
  };
  function getStyles() {
    return {
      textAlign: "left",
      borderRadius: "10px",
      padding: "1px 3px",
      fontSize: "14px",
      border: '1px solid #ccc'
    };
  }
  const handleUpload = async () => {

    setIsUploading(true);

    if (!filePondRef.current) {
      setMessage("Please select a file first!");
      return;
    }

    const pondInstance = filePondRef.current as unknown as FilePondInstance;
    const files = pondInstance.getFiles();
    if (files.length === 0) {
      setMessage("Please select a file first!");
      return;
    }

    const formData = new FormData();
    files.forEach((file) => {
      formData.append("file", file.file);
    });

    formData.append("metadata", JSON.stringify(metadata));

    try {
      const response = await axios.post(
        `${baseURL}documents/upload-nonpcode`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            'x-graph-authorization': `Bearer ${sessionStorage.getItem('msalAccessToken')}`,
            'Authorization': `Bearer ${sessionStorage.getItem('msalToken')}`,
          },
        }
      );

      setMessage(response.data.message || "File uploaded successfully!");
      setIsUploading(false);
      navigate(`/non-p-code`);

    } catch (error: any) {
      setMessage("Error uploading file: " + error?.response?.data?.error[0]);
      console.log(error?.response?.data?.error[0])
      setError(true);
      setIsUploading(false);
    }
  };

  const handleEdit = async () => {
    setIsUploading(true);
    const formData = new FormData();

    formData.append("metadata", JSON.stringify(metadata));

    try {
      const response = await axios.put(
        `${baseURL}documents/nonpcode/${document.documentId}`,
        metadata,
        {
          headers: {
            "Content-Type": "application/json",
            'x-graph-authorization': `Bearer ${sessionStorage.getItem('msalAccessToken')}`,
            'Authorization': `Bearer ${sessionStorage.getItem('msalToken')}`,
          },
        }
      );

      setMessage(response.data.message || "File uploaded successfully!");
      setIsUploading(false);
      navigate(`/non-p-code`);

    } catch (error: any) {
      setMessage("Error uploading file: " + error.message);
      setError(true);
      setIsUploading(false);
    }
  };

  function useDebounce(value, delay) {
    const [debouncedValue, setDebouncedValue] = useState(value);
    useEffect(() => {
      const handler = setTimeout(() => setDebouncedValue(value), delay);
      return () => clearTimeout(handler);
    }, [value, delay]);
    return debouncedValue;
  }

  const [inputValue, setInputValue] = useState("");
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const baseURL = `${import.meta.env.VITE_APP_API}`;
  const debouncedInput = useDebounce(inputValue, 500);

  useEffect(() => {
    if (!debouncedInput.trim()) {
      setOptions([]);
      return;
    }
    let active = true;
    setLoading(true);
    axios
      .get(`${baseURL}/ad/users/search?searchName=${encodeURIComponent(debouncedInput)}&count=10`, {
        headers: {
          'Authorization': `Bearer ${sessionStorage.getItem('msalAccessToken')}`
        },
      })
      .then((res) => {
        if (active) {
          setOptions(res.data.results || []);
        }
      })
      .catch((err) => {
        console.error("API Error:", err);
        if (active) setOptions([]);
      })
      .finally(() => {
        if (active) setLoading(false);
      });

    return () => {
      active = false;
    };
  }, [debouncedInput]);

  const handleRadio = (e) => {
    setConsent(!consent);
  };

  const handleDelete = (e: React.MouseEvent, v: string, name: string) => {
    e.stopPropagation();

    if (name === 'practiceIds') {
      // Remove the practice label
      const newPracticeLabels = { ...selectedFunctionalTopic1Labels };
      // (Assuming you have a label map for practices, if not, skip this step)

      // Remove all functionalTopicL1Ids that belong to the deleted practice
      const newFunctionalTopicL1Ids = metadata.functionalTopicL1Ids.filter(id => {
        const topic1 = functionalTopic1.find(t => t.functionalTopicL1Id === id);
        return topic1?.practiceId !== v;
      });

      // Remove all functionalTopicL2Ids that belong to those functionalTopicL1Ids
      const newFunctionalTopicL2Ids = metadata.functionalTopicL2Ids.filter(id => {
        const topic2 = functionalTopic2.find(t => t.functionalTopicL2Id === id);
        return !newFunctionalTopicL1Ids.includes(topic2?.functionalTopicL1Id);
      });

      // Update the label maps
      const newFunctionalTopic1Labels = { ...selectedFunctionalTopic1Labels };
      Object.keys(newFunctionalTopic1Labels).forEach(id => {
        const topic1 = functionalTopic1.find(t => t.functionalTopicL1Id === id);
        if (topic1?.practiceId === v) {
          delete newFunctionalTopic1Labels[id];
        }
      });

      const newFunctionalTopic2Labels = { ...selectedFunctionalTopic2Labels };
      Object.keys(newFunctionalTopic2Labels).forEach(id => {
        const topic2 = functionalTopic2.find(t => t.functionalTopicL2Id === id);
        if (!newFunctionalTopicL1Ids.includes(topic2?.functionalTopicL1Id)) {
          delete newFunctionalTopic2Labels[id];
        }
      });

      setSelectedFunctionalTopic1Labels(newFunctionalTopic1Labels);
      setSelectedFunctionalTopic2Labels(newFunctionalTopic2Labels);

      setMetadata(prev => ({
        ...prev,
        practiceIds: prev.practiceIds.filter((id: string) => id !== v),
        functionalTopicL1Ids: newFunctionalTopicL1Ids,
        functionalTopicL2Ids: newFunctionalTopicL2Ids,
      }));
    }
    else if (name === 'functionalTopicL1Ids') {
      const newLabels = { ...selectedFunctionalTopic1Labels };
      delete newLabels[v];
      setSelectedFunctionalTopic1Labels(newLabels);

      // Remove all functionalTopicL2Ids that belong to the deleted functionalTopicL1Id
      const newFunctionalTopicL2Ids = metadata.functionalTopicL2Ids.filter(id => {
        const topic2 = functionalTopic2.find(t => t.functionalTopicL2Id === id);
        return topic2?.functionalTopicL1Id !== v;
      });

      // Also remove the labels for those functionalTopicL2Ids
      const newFunctionalTopic2Labels = { ...selectedFunctionalTopic2Labels };
      Object.keys(newFunctionalTopic2Labels).forEach(id => {
        const topic2 = functionalTopic2.find(t => t.functionalTopicL2Id === id);
        if (topic2?.functionalTopicL1Id === v) {
          delete newFunctionalTopic2Labels[id];
        }
      });
      setSelectedFunctionalTopic2Labels(newFunctionalTopic2Labels);

      setMetadata(prev => ({
        ...prev,
        functionalTopicL1Ids: prev.functionalTopicL1Ids.filter((id: string) => id !== v),
        functionalTopicL2Ids: newFunctionalTopicL2Ids,
      }));
    }
    else if (name === 'functionalTopicL2Ids') {
      const newLabels = { ...selectedFunctionalTopic2Labels };
      delete newLabels[v];
      setSelectedFunctionalTopic2Labels(newLabels);
      setMetadata(prev => ({
        ...prev,
        [name]: prev[name]?.filter((id: string) => id !== v)
      }));
    }
    else {
      setMetadata(prev => ({
        ...prev,
        [name]: prev[name]?.filter((id: string) => id !== v)
      }));
    }
  };

  const handleSelectAll = (e) => {
    e.stopPropagation();
    const allMarketIds = markets?.map(m => m.marketId) || [];
    const newValue = metadata.marketIds.length === allMarketIds.length ? [] : allMarketIds;
    handleChange(allMarketIds, 'marketIds');
  };

  const filteredMarkets = markets.filter((option) => {
    if (marketInputValue !== '') {
      return option?.market.toLowerCase().includes(marketInputValue?.toLowerCase())
    }
    else return markets
  }
  );

  return (
    <div style={{ display: 'flex' }}>
      <div style={{ width: '70%' }}>
        <RenderIf isTrue={isUploading}>
          <Box
            sx={{
              position: "absolute",
              top: 0,
              right: 0,
              left: 0,
              bottom: 0,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              zIndex: 299,
              borderRadius: "10px",
              backgroundColor: "rgba(0, 0, 0, 0.5)",
            }}
          >
            <LoadingSpinner />
          </Box>
        </RenderIf>
        <RenderIf isTrue={error}>
          <Alert severity="error" className='mb-5'>
            {message}
          </Alert>
        </RenderIf>
        <RenderIf isTrue={window.location.href.indexOf("edit") < 0}>

          <div style={{
            display: "flex",
            flexDirection: "column",
            padding: '10px',
            gap: "20px",
            border: '1px solid #ccc',
            borderRadius: '10px',
            margin: '10px'
          }}>
            <h4 style={{ margin: '10px' }}>Upload document</h4>

            <FilePond
              disabled={window.location.href.indexOf("edit") > -1}
              allowFileSizeValidation={true}
              maxFileSize={`100MB`}
              ref={filePondRef}
              allowMultiple={false}
              maxFiles={1}
              instantUpload={false}
              name="files"
              labelIdle='Drag & Drop your file or <span class="filepond--label-action" style="color: #0000FF ">Browse</span>
            <br/><span  style="font-size: 12px">Supported formats: PDF, DOC, DOCX, PPT, PPTX, XLS, XLSX • Max size: 200MB</span>'
              acceptedFileTypes={[
                "application/pdf",
                "image/jpeg",
                "image/png",
                'text/markdown',
                'text/x-markdown'
              ]}
              onaddfile={handleFileAdd}
            />
            <Box component="span" sx={{ color: "red" }}>
              {filenameError}
            </Box>


          </div>
        </RenderIf>

        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: "20px",
          }}
        >
          <div style={{
            display: "flex",
            flexDirection: "column",
            padding: '10px',
            gap: "20px",
            border: '1px solid #ccc',
            borderRadius: '10px',
            margin: '10px'
          }}>
            <h4 style={{ margin: '10px' }}>Document information</h4>
            <TextField
              sx={{
                "& fieldset": {
                  border: "1px solid #ccc !important",
                  borderRadius: '10px'
                },
              }}
              label="File Name*"
              value={fileName}
              onChange={(e) => handleFileName(e.target.value)}
              error={!!filenameError}
              helperText={filenameError}
            //disabled={window.location.href.indexOf("edit") > -1}


            />
            <FormControl>
              <InputLabel id="fileCategory" style={{ background: 'white' }}>Document Category*</InputLabel>
              <Select
                labelId="Category"
                id="Category"
                value={metadata.categoryId}
                onChange={(e) => handleChange(e.target.value, 'categoryId')}
                sx={getStyles()}
              >
                {categories?.map((category) => (
                  <MenuItem
                    key={category.documentCategoryId}
                    value={category.documentCategoryId}
                  >

                    <Box
                      sx={{
                        display: "flex",
                        width: "100%",
                        justifyContent: "space-between",
                      }}
                    >
                      {category.name}


                    </Box>

                  </MenuItem>
                ))}
              </Select>
            </FormControl>


          </div>
          <div style={{
            display: "flex",
            flexDirection: "column",
            padding: '10px',

            gap: "20px",
            border: '1px solid #ccc',
            borderRadius: '10px',
            margin: '10px'
          }}>
            <h4 style={{ margin: '10px' }}>Industry & market context</h4>
            <Alert severity="info" className='mb-5'>
              At least one of the following fields is required: Account Industry or Functional Practice
            </Alert>

            <FormControl>
              <InputLabel id="fileCategory" style={{ background: 'white' }}>Market*</InputLabel>
              <Select
                onOpen={() => setTimeout(() => document.querySelector('#search-input')?.focus(), 100)}
                labelId="Markets"
                id="Markets"
                multiple
                value={metadata.marketIds}
                onChange={(e) => handleChange(e.target.value, 'marketIds')}
                sx={getStyles()}
                MenuProps={{
                  anchorOrigin: {
                    vertical: "bottom",
                    horizontal: "left",
                  },
                  transformOrigin: {
                    vertical: "top",
                    horizontal: "left",
                  },
                  PaperProps: {
                    style: {
                      maxHeight: 300,
                    },
                  },
                }}
                renderValue={(selected) => {
                  return (
                    <div style={{ display: 'flex', gap: '5px' }}>
                      {selected.map((id) => {
                        const market = markets?.find((m) => m.marketId === id);
                        if (!market) return null;

                        return (
                          <Chip
                            key={id}
                            label={market.market}
                            onMouseDown={(event) => event.stopPropagation()}
                            onDelete={(e) => handleDelete(e, id, 'marketIds')}
                            onClick={() => console.log("clicked chip")}
                          />
                        );
                      })}
                    </div>
                  );
                }}

              >
                <MenuItem disableRipple disableTouchRipple>
                  <TextField
                    autoFocus
                    id="search-input"
                    placeholder="Search"
                    value={marketInputValue}
                    onChange={(e) => setMarketInputValue(e.target.value)}
                    fullWidth
                    onKeyDown={(e) => e.stopPropagation()}
                  />
                </MenuItem>
                <MenuItem onClick={handleSelectAll}>
                  <ListItemText primary="Select All" />
                </MenuItem>
                {filteredMarkets?.map((category) => {
                  const selected = metadata?.marketIds.includes(category.marketId);
                  const SelectionIcon = selected ? CheckBoxIcon : CheckBoxOutlineBlankIcon;

                  return (
                    <MenuItem key={category.marketId} value={category.marketId}>
                      <SelectionIcon
                        fontSize="small"
                        style={{ marginRight: 8, padding: 9, boxSizing: 'content-box' }}
                      />
                      <ListItemText primary={category.market} />
                    </MenuItem>
                  );
                })}
              </Select>
              <p style={{ margin: '5px', fontSize: '12px', color: 'grey' }}>Market(s) where the document is commercially relevant</p>

            </FormControl>
            <FormControl>
              <InputLabel id="fileCategory" style={{ background: 'white' }}>Account Industry</InputLabel>
              <Select
                labelId="Industry"
                id="Industry"
                value={metadata.accountIndustryId}
                onChange={(e) => handleChange(e.target.value, 'accountIndustryId')}
                sx={getStyles()}
              >
                {industries?.map((category) => (
                  <MenuItem
                    key={category.industryId}
                    value={category.industryId}
                  >

                    <Box
                      sx={{
                        display: "flex",
                        width: "100%",
                        justifyContent: "space-between",
                      }}
                    >
                      {category.industryPractice}


                    </Box>

                  </MenuItem>
                ))}
              </Select>
              <p style={{ margin: '5px', fontSize: '12px', color: 'grey' }}>Industry or industries of the client(s) for which this document has been produced or has commercial relevance (e.g., ENUR)</p>

            </FormControl>

            <RenderIf isTrue={metadata.accountIndustryId}>

              <FormControl>
                <InputLabel id="fileCategory" style={{ background: 'white' }}>Account Sub Industry*</InputLabel>
                <Select
                  multiple
                  labelId="SubIndustry"
                  id="SubIndustry"
                  value={metadata.accountSubindustryL1Ids}
                  onChange={(e) => handleChange(e.target.value, 'accountSubindustryL1Ids')}
                  sx={getStyles()}
                  MenuProps={{
                    anchorOrigin: {
                      vertical: "bottom",
                      horizontal: "left",
                    },
                    transformOrigin: {
                      vertical: "top",
                      horizontal: "left",
                    },
                    PaperProps: {
                      style: {
                        maxHeight: 300,
                      },
                    },
                  }}
                  renderValue={(selected) => {
                    return (
                      <div style={{ display: 'flex', gap: '5px' }}>
                        {selected.map((id) => {
                          const subindustry = subindustries?.find((m) => m.subindustryL1Id === id);
                          if (!subindustry) return null;

                          return (
                            <Chip
                              key={id}
                              label={subindustry.subindustryL1}
                              onMouseDown={(event) => event.stopPropagation()}
                              onDelete={(e) => handleDelete(e, id, 'accountSubindustryL1Ids')}
                              onClick={() => console.log("clicked chip")}
                            />
                          );
                        })}
                      </div>
                    );
                  }}

                >
                  {subindustries?.map((category) => {
                    const selected = metadata?.accountSubindustryL1Ids.includes(category.subindustryL1Id);
                    const SelectionIcon = selected ? CheckBoxIcon : CheckBoxOutlineBlankIcon;

                    return (
                      <MenuItem key={category.subindustryL1Id} value={category.subindustryL1Id}>
                        <SelectionIcon
                          fontSize="small"
                          style={{ marginRight: 8, padding: 9, boxSizing: 'content-box' }}
                        />
                        <ListItemText primary={category.subindustryL1} />
                      </MenuItem>
                    );
                  })}
                </Select>
                <p style={{ margin: '5px', fontSize: '12px', color: 'grey' }}>Sub-industry/industries of the client(s) for which this document has been produced or has commercial relevance (e.g., Metals & Mining)</p>

              </FormControl>

            </RenderIf>
            <RenderIf isTrue={true}>

              <FormControl>
                <InputLabel id="fileCategory" style={{ background: 'white' }}>Industry Practice</InputLabel>
                <Select
                  labelId="IndustryPractice"
                  id="IndustryPractice"
                  value={metadata.industryId}
                  onChange={(e) => handleChange(e.target.value, 'industryId')}
                  sx={getStyles()}
                >
                  {industries?.map((category) => (
                    <MenuItem
                      key={category.industryId}
                      value={category.industryId}
                    >

                      <Box
                        sx={{
                          display: "flex",
                          width: "100%",
                          justifyContent: "space-between",
                        }}
                      >
                        {category.industryPractice}


                      </Box>

                    </MenuItem>
                  ))}
                </Select>
                <p style={{ margin: '5px', fontSize: '12px', color: 'grey' }}>ADL industry that has delivered this work.</p>

              </FormControl>
            </RenderIf>
          </div>

          <div style={{
            display: "flex",
            flexDirection: "column",
            padding: '10px',

            gap: "20px",
            border: '1px solid #ccc',
            borderRadius: '10px',
            margin: '10px'
          }}>
            <h4 style={{ margin: '10px' }}>Functional Capability</h4>

            <FormControl>
              <InputLabel id="fileCategory" style={{ background: 'white' }}>Functional Practice</InputLabel>
              <Select
                multiple
                labelId="Practice"
                id="Practice"
                value={metadata.practiceIds}
                onChange={(e) => handleChange(e.target.value, 'practiceIds')}
                sx={getStyles()}
                MenuProps={{
                  anchorOrigin: {
                    vertical: "bottom",
                    horizontal: "left",
                  },
                  transformOrigin: {
                    vertical: "top",
                    horizontal: "left",
                  },
                  PaperProps: {
                    style: {
                      maxHeight: 300,
                    },
                  },
                }}
                renderValue={(selected) => {
                  return (
                    <div style={{ display: 'flex', gap: '5px' }}>
                      {selected.map((id) => {
                        const practice = practices?.find((m) => m.practiceId === id);
                        if (!practice) return null;

                        return (
                          <Chip
                            key={id}
                            label={practice.functionalPractice}
                            onMouseDown={(event) => event.stopPropagation()}
                            onDelete={(e) => handleDelete(e, id, 'practiceIds')}
                            onClick={() => console.log("clicked chip")}
                          />
                        );
                      })}
                    </div>
                  );
                }}

              >
                {practices?.map((category) => {
                  const selected = metadata?.practiceIds.includes(category.practiceId);
                  const SelectionIcon = selected ? CheckBoxIcon : CheckBoxOutlineBlankIcon;

                  return (
                    <MenuItem key={category.practiceId} value={category.practiceId}>
                      <SelectionIcon
                        fontSize="small"
                        style={{ marginRight: 8, padding: 9, boxSizing: 'content-box' }}
                      />
                      <ListItemText primary={category.functionalPractice} />
                    </MenuItem>
                  );
                })}
              </Select>
              <p style={{ margin: '5px', fontSize: '12px', color: 'grey' }}>ADL functional practice that has delivered this work.</p>

            </FormControl>
            <RenderIf isTrue={metadata.practiceIds.length > 0}>

              <FormControl>
                <InputLabel id="fileCategory" style={{ background: 'white' }}>Functional Topic*</InputLabel>
                <Select
                  multiple
                  labelId="functionalTopicL1"
                  id="functionalTopicL1"
                  value={metadata.functionalTopicL1Ids}
                  onChange={(e) => handleChange(e.target.value, 'functionalTopicL1Ids')}
                  sx={getStyles()}
                  MenuProps={{
                    anchorOrigin: {
                      vertical: "bottom",
                      horizontal: "left",
                    },
                    transformOrigin: {
                      vertical: "top",
                      horizontal: "left",
                    },
                    PaperProps: {
                      style: {
                        maxHeight: 300,
                      },
                    },
                  }}
                  renderValue={(selected) => {
                    return (
                      <div style={{ display: 'flex', gap: '5px' }}>
                        {selected.map((id) => {
                          const label = selectedFunctionalTopic1Labels[id] || `Unknown (${id})`;
                          return (
                            <Chip
                              key={id}
                              label={label}
                              onMouseDown={(event) => event.stopPropagation()}
                              onDelete={(e) => handleDelete(e, id, 'functionalTopicL1Ids')}
                            />
                          );
                        })}
                      </div>
                    );
                  }}
                >

                  {functionalTopic1?.map((category) => {
                    const selected = metadata?.functionalTopicL1Ids.includes(category.functionalTopicL1Id);
                    const SelectionIcon = selected ? CheckBoxIcon : CheckBoxOutlineBlankIcon;

                    return (
                      <MenuItem key={category.functionalTopicL1Id} value={category.functionalTopicL1Id}>
                        <SelectionIcon
                          fontSize="small"
                          style={{ marginRight: 8, padding: 9, boxSizing: 'content-box' }}
                        />
                        <ListItemText primary={category.functionalTopicL1} />
                      </MenuItem>
                    );
                  })}
                </Select>
                <p style={{ margin: '5px', fontSize: '12px', color: 'grey' }}>Main functional topic (e.g., Procurement).</p>

              </FormControl>

            </RenderIf>
            <RenderIf isTrue={metadata.functionalTopicL1Ids.length > 0}>

              <FormControl>
                <InputLabel id="fileCategory" style={{ background: 'white' }}>Functional subtopic*</InputLabel>
                <Select
                  multiple
                  labelId="functionalTopicL2"
                  id="functionalTopicL2"
                  value={metadata.functionalTopicL2Ids}
                  onChange={(e) => handleChange(e.target.value, 'functionalTopicL2Ids')}
                  sx={getStyles()}
                  MenuProps={{
                    anchorOrigin: {
                      vertical: "bottom",
                      horizontal: "left",
                    },
                    transformOrigin: {
                      vertical: "top",
                      horizontal: "left",
                    },
                    PaperProps: {
                      style: {
                        maxHeight: 300,
                      },
                    },
                  }}
                  renderValue={(selected) => {
                    return (
                      <div style={{ display: 'flex', gap: '5px' }}>
                        {selected.map((id) => {
                          const label = selectedFunctionalTopic2Labels[id] || `Unknown (${id})`;
                          return (
                            <Chip
                              key={id}
                              label={label}
                              onMouseDown={(event) => event.stopPropagation()}
                              onDelete={(e) => handleDelete(e, id, 'functionalTopicL2Ids')}
                            />
                          );
                        })}
                      </div>
                    );
                  }}
                >

                  {functionalTopic2?.map((category) => {
                    const selected = metadata?.functionalTopicL2Ids.includes(category.functionalTopicL2Id);
                    const SelectionIcon = selected ? CheckBoxIcon : CheckBoxOutlineBlankIcon;

                    return (
                      <MenuItem key={category.functionalTopicL2Id} value={category.functionalTopicL2Id}>
                        <SelectionIcon
                          fontSize="small"
                          style={{ marginRight: 8, padding: 9, boxSizing: 'content-box' }}
                        />
                        <ListItemText primary={category.functionalTopicL2} />
                      </MenuItem>
                    );
                  })}
                </Select>
                <p style={{ margin: '5px', fontSize: '12px', color: 'grey' }}>Specific subject within the functional topic (e.g., Supply Chain Risk Management).</p>

              </FormControl>

            </RenderIf>
          </div>
          <div style={{
            display: "flex",
            flexDirection: "column",
            padding: '10px',

            gap: "20px",
            border: '1px solid #ccc',
            borderRadius: '10px',
            margin: '10px'
          }}>
            <h4 style={{ margin: '10px' }}>Authors</h4>

            <FormControl>

              <Select
                multiple
                displayEmpty
                value={metadata.authorEmails}
                onChange={(e) => { if (!e.target.value.includes(undefined)) { handleChange(e.target.value, 'authorEmails') } }}
                input={<OutlinedInput />}
                renderValue={(selected) => {
                  return (
                    <div style={{ display: 'flex', gap: '5px' }}>

                      {selected.map((id) => {
                        const authors = metadata?.authorEmails?.find((m) => m === id);
                        if (!metadata || !authors) return null;


                        return (
                          <Chip
                            key={id}
                            label={authors} // show name in UI
                            onMouseDown={(event) => event.stopPropagation()}
                            onDelete={(e) => handleDelete(e, id, 'authorEmails')}
                            onClick={() => console.log("clicked chip")}
                          />
                        );
                      })}
                    </div>
                  );
                }}
                MenuProps={{
                  PaperProps: {
                    style: { maxHeight: 300 }
                  }
                }}
              >
                {/* Search input inside dropdown */}
                <MenuItem disableRipple disableTouchRipple>
                  <TextField
                    placeholder="Search by name or email..."
                    value={inputValue}
                    onChange={(e) => {
                      e.stopPropagation()
                      return (setInputValue(e.target.value))
                    }}
                    fullWidth
                  />
                </MenuItem>

                {/* Filtered options */}
                {options?.length > 0 && options?.map((option) => (
                  <MenuItem key={option.email} value={option.email}

                  >
                    {option.name}
                  </MenuItem>
                ))}
              </Select>
              <p style={{ margin: '5px', fontSize: '12px', color: 'grey' }}>ADL team member(s) who developed the core content and would be credited on the document.</p>

            </FormControl>

          </div>
          <FormControlLabel style={{ margin: '10px' }} value={consent} control={<Checkbox checked={consent} value={consent} onChange={handleRadio} />} label="I confirm that this file contains no confidential  or restricted information" />

        </Box>
        <div style={{ display: 'flex', marginTop: '50px', gap: '10px', width: '30%', float: 'right' }}>
          <Button
            variant="outlined"
            disableElevation
            onClick={() => navigate('/non-p-code')}
            sx={{ width: "100%" }}
          >
            Cancel
          </Button>
          <RenderIf isTrue={window.location.href.indexOf("edit") > -1}>
            <Button
              variant="contained"
              disableElevation
              disabled={disableSubmit}
              onClick={() => {
                handleEdit()
              }}
              sx={{ width: "100%" }}
            >
              Submit
            </Button>
          </RenderIf>
          <RenderIf isTrue={window.location.href.indexOf("edit") < 0}>
            <Button
              variant="contained"
              disableElevation
              disabled={disableSubmit}
              onClick={() => {
                setDisableSubmit(true);
                handleUpload()
              }}
              sx={{ width: "100%" }}
            >
              Submit
            </Button>
          </RenderIf>
        </div>
      </div>
      <div style={{ borderRadius: '20px', background: '#DFDFFD', width: '320px', padding: '20px', height: '200px', margin: '10px' }}>
        <h4>What are Non-P-Codes documents?</h4>
        <p>Upload documents that are not linked to a specific case but may be useful for colleagues. They will be searchable in SmartSearch.</p>
      </div>
    </div>

  );
};

export default FileMetaModal;
